function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute("role", "button");
  summary.setAttribute(
    "aria-expanded",
    summary.parentNode.hasAttribute("open")
  );

  if (summary.nextElementSibling && summary.nextElementSibling.getAttribute("id")) {
    summary.setAttribute("aria-controls", summary.nextElementSibling.id);
  }


  summary.addEventListener("click", (event) => {
    if (!event.currentTarget.closest("details").hasAttribute("open")) {
      closeAccordion();
    }
    event.currentTarget.setAttribute(
      "aria-expanded",
      !event.currentTarget.closest("details").hasAttribute("open")
    );
  });

  if (summary.closest("header-drawer, menu-drawer")) return;
  summary.parentElement.addEventListener("keyup", onKeyUpEscape);
});

window.trapFocusHandlers = {};

function closeAccordion() {
  let openedAccordion = document.querySelector(
    ".rocket-scalpers-main-product__accordion-wrapper details[open]"
  );
  if (openedAccordion) {
    openedAccordion.removeAttribute("open");
    openedAccordion
      .querySelector("summary")
      ?.setAttribute("aria-expanded", false);
  }
}

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== "TAB") return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener("focusout", trapFocusHandlers.focusout);
  document.addEventListener("focusin", trapFocusHandlers.focusin);

  elementToFocus.focus();

  if (
    elementToFocus.tagName === "INPUT" &&
    ["search", "text", "email", "url"].includes(elementToFocus.type) &&
    elementToFocus.value
  ) {
    elementToFocus.setSelectionRange(0, elementToFocus.value.length);
  }
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(":focus-visible");
} catch (e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = [
    "ARROWUP",
    "ARROWDOWN",
    "ARROWLEFT",
    "ARROWRIGHT",
    "TAB",
    "ENTER",
    "SPACE",
    "ESCAPE",
    "HOME",
    "END",
    "PAGEUP",
    "PAGEDOWN",
  ];
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener("keydown", (event) => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener("mousedown", (event) => {
    mouseClick = true;
  });

  window.addEventListener(
    "focus",
    () => {
      if (currentFocusedElement)
        currentFocusedElement.classList.remove("focused");

      if (mouseClick) return;

      currentFocusedElement = document.activeElement;
      currentFocusedElement.classList.add("focused");
    },
    true
  );
}

function pauseAllMedia() {
  document.querySelectorAll(".js-youtube").forEach((video) => {
    video.contentWindow.postMessage(
      '{"event":"command","func":"' + "pauseVideo" + '","args":""}',
      "*"
    );
  });
  document.querySelectorAll(".js-vimeo").forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', "*");
  });
  document.querySelectorAll("video").forEach((video) => video.pause());
  document.querySelectorAll("product-model").forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener("focusin", trapFocusHandlers.focusin);
  document.removeEventListener("focusout", trapFocusHandlers.focusout);
  document.removeEventListener("keydown", trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== "ESCAPE") return;

  const openDetailsElement = event.target.closest("details[open]");
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector("summary");
  openDetailsElement.removeAttribute("open");
  summaryElement.setAttribute("aria-expanded", false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector("input");
    this.changeEvent = new Event("change", { bubbles: true });

    this.input.addEventListener("change", this.onInputChange.bind(this));
    this.querySelectorAll("button").forEach((button) =>
      button.addEventListener("click", this.onButtonClick.bind(this))
    );
  }

  quantityUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.validateQtyRules();
    this.quantityUpdateUnsubscriber = subscribe(
      PUB_SUB_EVENTS.quantityUpdate,
      this.validateQtyRules.bind(this)
    );
  }

  disconnectedCallback() {
    if (this.quantityUpdateUnsubscriber) {
      this.quantityUpdateUnsubscriber();
    }
  }

  onInputChange(event) {
    this.validateQtyRules();
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === "plus" ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value)
      this.input.dispatchEvent(this.changeEvent);
  }

  validateQtyRules() {
    const value = parseInt(this.input.value);
    if (this.input.min) {
      const min = parseInt(this.input.min);
      const buttonMinus = this.querySelector(".quantity__button[name='minus']");
      buttonMinus.classList.toggle("disabled", value <= min);
    }
    if (this.input.max) {
      const max = parseInt(this.input.max);
      const buttonPlus = this.querySelector(".quantity__button[name='plus']");
      buttonPlus.classList.toggle("disabled", value >= max);
    }
  }
}

customElements.define("quantity-input", QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function fetchConfig(type = "json") {
  return {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: `application/${type}`,
    },
  };
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == "undefined") {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent("on" + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options["method"] || "post";
  var params = options["parameters"] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for (var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (
  country_domid,
  province_domid,
  options
) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(
    options["hideElement"] || province_domid
  );

  Shopify.addListener(
    this.countryEl,
    "change",
    Shopify.bind(this.countryHandler, this)
  );

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute("data-default");
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute("data-default");
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute("data-provinces");
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = "none";
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement("option");
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement("option");
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector("details");

    this.addEventListener("keyup", this.onKeyUp.bind(this));
    this.addEventListener("focusout", this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll("summary").forEach((summary) =>
      summary.addEventListener("click", this.onSummaryClick.bind(this))
    );
    this.querySelectorAll("button:not(.localization-selector)").forEach(
      (button) =>
        button.addEventListener("click", this.onCloseButtonClick.bind(this))
    );
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== "ESCAPE") return;

    const openDetailsElement = event.target.closest("details[open]");
    if (!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle
      ? this.closeMenuDrawer(
          event,
          this.mainDetailsToggle.querySelector("summary")
        )
      : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest(".has-submenu");
    const isOpen = detailsElement.hasAttribute("open");
    const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");

    function addTrapFocus() {
      trapFocus(
        summaryElement.nextElementSibling,
        detailsElement.querySelector("button")
      );
      summaryElement.nextElementSibling.removeEventListener(
        "transitionend",
        addTrapFocus
      );
    }

    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault();
      isOpen
        ? this.closeMenuDrawer(event, summaryElement)
        : this.openMenuDrawer(summaryElement);

      if (window.matchMedia("(max-width: 990px)")) {
        document.documentElement.style.setProperty(
          "--viewport-height",
          `${window.innerHeight}px`
        );
      }
    } else {
      setTimeout(() => {
        detailsElement.classList.add("menu-opening");
        summaryElement.setAttribute("aria-expanded", true);
        parentMenuElement && parentMenuElement.classList.add("submenu-open");
        !reducedMotion || reducedMotion.matches
          ? addTrapFocus()
          : summaryElement.nextElementSibling.addEventListener(
              "transitionend",
              addTrapFocus
            );
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add("menu-opening");
    });
    summaryElement.setAttribute("aria-expanded", true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    this.mainDetailsToggle.classList.remove("menu-opening");
    this.mainDetailsToggle.querySelectorAll("details").forEach((details) => {
      details.removeAttribute("open");
      details.classList.remove("menu-opening");
    });
    this.mainDetailsToggle
      .querySelectorAll(".submenu-open")
      .forEach((submenu) => {
        submenu.classList.remove("submenu-open");
      });
    document.body.classList.remove(
      `overflow-hidden-${this.dataset.breakpoint}`
    );
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);

    if (event instanceof KeyboardEvent)
      elementToFocus?.setAttribute("aria-expanded", false);
  }

  onFocusOut() {
    setTimeout(() => {
      if (
        this.mainDetailsToggle.hasAttribute("open") &&
        !this.mainDetailsToggle.contains(document.activeElement)
      )
        this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest("details");
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest(".submenu-open");
    parentMenuElement && parentMenuElement.classList.remove("submenu-open");
    detailsElement.classList.remove("menu-opening");
    detailsElement
      .querySelector("summary")
      .setAttribute("aria-expanded", false);
    removeTrapFocus(detailsElement.querySelector("summary"));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute("open");
        if (detailsElement.closest("details[open]")) {
          trapFocus(
            detailsElement.closest("details[open]"),
            detailsElement.querySelector("summary")
          );
        }
      }
    };

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define("menu-drawer", MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.querySelector(".section-header");
    this.borderOffset =
      this.borderOffset ||
      this.closest(".header-wrapper").classList.contains(
        "header-wrapper--border-bottom"
      )
        ? 1
        : 0;
    document.documentElement.style.setProperty(
      "--header-bottom-position",
      `${parseInt(
        this.header.getBoundingClientRect().bottom - this.borderOffset
      )}px`
    );
    this.header.classList.add("menu-open");

    setTimeout(() => {
      this.mainDetailsToggle.classList.add("menu-opening");
    });

    summaryElement.setAttribute("aria-expanded", true);
    window.addEventListener("resize", this.onResize);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus) {
    if (!elementToFocus) return;
    super.closeMenuDrawer(event, elementToFocus);
    this.header.classList.remove("menu-open");
    this.header.classList.remove("two-bars-open");
    window.removeEventListener("resize", this.onResize);
  }

  onResize = () => {
    this.header &&
      document.documentElement.style.setProperty(
        "--header-bottom-position",
        `${parseInt(
          this.header.getBoundingClientRect().bottom - this.borderOffset
        )}px`
      );
    document.documentElement.style.setProperty(
      "--viewport-height",
      `${window.innerHeight}px`
    );
  };
}

customElements.define("header-drawer", HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      "click",
      this.hide.bind(this, false)
    );
    this.addEventListener("keyup", (event) => {
      if (event.code.toUpperCase() === "ESCAPE") this.hide();
    });
    if (this.classList.contains("media-modal")) {
      this.addEventListener("pointerup", (event) => {
        if (
          event.pointerType === "mouse" &&
          !event.target.closest("deferred-media, product-model")
        )
          this.hide();
      });
    } else {
      this.addEventListener("click", (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector(".template-popup");
    document.body.classList.add("overflow-hidden");
    this.setAttribute("open", "");
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    if (!this.classList.contains("add-all-modal")) {
      document.body.classList.remove("overflow-hidden");
    }
    document.body.dispatchEvent(new CustomEvent("modalClosed"));
    this.removeAttribute("open");
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define("modal-dialog", ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector("button");
    const link = this.querySelector("a");
    if (button) {
      button.addEventListener("click", (e) => {
        e.preventDefault();
        const modal = document.querySelector(this.getAttribute("data-modal"));
        if (modal) modal.show(button);
      });
    }
    if (link) {
      link.addEventListener("click", (e) => {
        e.preventDefault();
        const modal = document.querySelector(this.getAttribute("data-modal"));
        if (modal) modal.show(link);
      });
    }
  }
}
customElements.define("modal-opener", ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener("click", this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute("loaded")) {
      const content = document.createElement("div");
      content.appendChild(
        this.querySelector("template").content.firstElementChild.cloneNode(true)
      );

      this.setAttribute("loaded", true);
      const deferredElement = this.appendChild(
        content.querySelector("video, model-viewer, iframe")
      );
      if (focus) deferredElement.focus();
      if (
        deferredElement.nodeName == "VIDEO" &&
        deferredElement.getAttribute("autoplay")
      ) {
        // force autoplay for safari
        deferredElement.play();
      }
    }
  }
}

customElements.define("deferred-media", DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector(".slider-counter--current");
    this.pageTotalElement = this.querySelector(".slider-counter--total");
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    this.initPages();
    const resizeObserver = new ResizeObserver((entries) => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener("scroll", this.update.bind(this));
    this.prevButton.addEventListener("click", this.onButtonClick.bind(this));
    this.nextButton.addEventListener("click", this.onButtonClick.bind(this));
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter(
      (element) => element.clientWidth > 0
    );
    if (this.sliderItemsToShow.length < 2) return;
    this.sliderItemOffset =
      this.sliderItemsToShow[1].offsetLeft -
      this.sliderItemsToShow[0].offsetLeft;
    this.slidesPerPage = Math.floor(
      (this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) /
        this.sliderItemOffset
    );
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    // Temporarily prevents unneeded updates resulting from variant changes
    // This should be refactored as part of https://github.com/Shopify/dawn/issues/2057
    if (!this.slider || !this.nextButton) return;

    const previousPage = this.currentPage;
    this.currentPage =
      Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(
        new CustomEvent("slideChanged", {
          detail: {
            currentPage: this.currentPage,
            currentElement: this.sliderItemsToShow[this.currentPage - 1],
          },
        })
      );
    }

    if (this.enableSliderLooping) return;

    if (
      this.isSlideVisible(this.sliderItemsToShow[0]) &&
      this.slider.scrollLeft === 0
    ) {
      this.prevButton.setAttribute("disabled", "disabled");
    } else {
      this.prevButton.removeAttribute("disabled");
    }

    if (
      this.isSlideVisible(
        this.sliderItemsToShow[this.sliderItemsToShow.length - 1]
      )
    ) {
      this.nextButton.setAttribute("disabled", "disabled");
    } else {
      this.nextButton.removeAttribute("disabled");
    }
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide =
      this.slider.clientWidth + this.slider.scrollLeft - offset;
    return (
      element.offsetLeft + element.clientWidth <= lastVisibleSlide &&
      element.offsetLeft >= this.slider.scrollLeft
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition =
      event.currentTarget.name === "next"
        ? this.slider.scrollLeft + step * this.sliderItemOffset
        : this.slider.scrollLeft - step * this.sliderItemOffset;
    this.slider.scrollTo({
      left: this.slideScrollPosition,
    });
  }
}

customElements.define("slider-component", SliderComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector(".slider-buttons");
    this.enableSliderLooping = true;

    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector(".slideshow__slide");
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.sliderControlLinksArray = Array.from(
      this.sliderControlWrapper.querySelectorAll(".slider-counter__link")
    );
    this.sliderControlLinksArray.forEach((link) =>
      link.addEventListener("click", this.linkToSlide.bind(this))
    );
    this.slider.addEventListener("scroll", this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    if (this.querySelector(".announcement-bar-slider")) {
      this.announcementBarArrowButtonWasClicked = false;

      this.desktopLayout = window.matchMedia("(min-width: 750px)");
      this.reducedMotion = window.matchMedia(
        "(prefers-reduced-motion: reduce)"
      );

      [this.reducedMotion, this.desktopLayout].forEach((mediaQuery) => {
        mediaQuery.addEventListener("change", () => {
          if (this.slider.getAttribute("data-autoplay") === "true")
            this.setAutoPlay();
        });
      });

      [this.prevButton, this.nextButton].forEach((button) => {
        button.addEventListener(
          "click",
          () => {
            this.announcementBarArrowButtonWasClicked = true;
          },
          { once: true }
        );
      });
    }

    if (this.slider.getAttribute("data-autoplay") === "true")
      this.setAutoPlay();
  }

  setAutoPlay() {
    this.autoplaySpeed = this.slider.dataset.speed * 1000;
    this.addEventListener("mouseover", this.focusInHandling.bind(this));
    this.addEventListener("mouseleave", this.focusOutHandling.bind(this));
    this.addEventListener("focusin", this.focusInHandling.bind(this));
    this.addEventListener("focusout", this.focusOutHandling.bind(this));

    if (this.querySelector(".slideshow__autoplay")) {
      this.sliderAutoplayButton = this.querySelector(".slideshow__autoplay");
      this.sliderAutoplayButton.addEventListener(
        "click",
        this.autoPlayToggle.bind(this)
      );
      this.autoplayButtonIsSetToPlay = true;
      this.play();
    } else {
      this.reducedMotion.matches ||
      this.announcementBarArrowButtonWasClicked ||
      !this.desktopLayout.matches
        ? this.pause()
        : this.play();
    }
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) return;

    if (isFirstSlide && event.currentTarget.name === "previous") {
      this.slideScrollPosition =
        this.slider.scrollLeft +
        this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === "next") {
      this.slideScrollPosition = 0;
    }
    this.slider.scrollTo({
      left: this.slideScrollPosition,
    });
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll(".slider-counter__link");
    this.prevButton.removeAttribute("disabled");

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach((link) => {
      link.classList.remove("slider-counter__link--active");
      link.removeAttribute("aria-current");
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add(
      "slider-counter__link--active"
    );
    this.sliderControlButtons[this.currentPage - 1].setAttribute(
      "aria-current",
      true
    );
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    if (this.sliderAutoplayButton) {
      const focusedOnAutoplayButton =
        event.target === this.sliderAutoplayButton ||
        this.sliderAutoplayButton.contains(event.target);
      if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
      this.play();
    } else if (
      !this.reducedMotion.matches &&
      !this.announcementBarArrowButtonWasClicked &&
      this.desktopLayout.matches
    ) {
      this.play();
    }
  }

  focusInHandling(event) {
    if (this.sliderAutoplayButton) {
      const focusedOnAutoplayButton =
        event.target === this.sliderAutoplayButton ||
        this.sliderAutoplayButton.contains(event.target);
      if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
        this.play();
      } else if (this.autoplayButtonIsSetToPlay) {
        this.pause();
      }
    } else if (
      this.querySelector(".announcement-bar-slider").contains(event.target)
    ) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute("aria-live", "off");
    clearInterval(this.autoplay);
    this.autoplay = setInterval(
      this.autoRotateSlides.bind(this),
      this.autoplaySpeed
    );
  }

  pause() {
    this.slider.setAttribute("aria-live", "polite");
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add("slideshow__autoplay--paused");
      this.sliderAutoplayButton.setAttribute(
        "aria-label",
        window.accessibilityStrings.playSlideshow
      );
    } else {
      this.sliderAutoplayButton.classList.remove("slideshow__autoplay--paused");
      this.sliderAutoplayButton.setAttribute(
        "aria-label",
        window.accessibilityStrings.pauseSlideshow
      );
    }
  }

  autoRotateSlides() {
    const slideScrollPosition =
      this.currentPage === this.sliderItems.length
        ? 0
        : this.slider.scrollLeft +
          this.slider.querySelector(".slideshow__slide").clientWidth;
    this.slider.scrollTo({
      left: slideScrollPosition,
    });
  }

  setSlideVisibility() {
    this.sliderItemsToShow.forEach((item, index) => {
      const linkElements = item.querySelectorAll("a");
      if (index === this.currentPage - 1) {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.removeAttribute("tabindex");
          });
        item.setAttribute("aria-hidden", "false");
        item.removeAttribute("tabindex");
      } else {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.setAttribute("tabindex", "-1");
          });
        item.setAttribute("aria-hidden", "true");
        item.setAttribute("tabindex", "-1");
      }
    });
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition =
      this.slider.scrollLeft +
      this.sliderFirstItemNode.clientWidth *
        (this.sliderControlLinksArray.indexOf(event.currentTarget) +
          1 -
          this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition,
    });
  }
}

customElements.define("slideshow-component", SlideshowComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("change", this.onVariantChange);
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, "", false);
    this.updatePickupAvailability();
    this.removeErrorMessage();
    this.updateVariantStatuses();

    if (!this.currentVariant) {
      this.toggleAddButton(true, "", true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();
    }
  }

  updateOptions() {
    this.options = Array.from(
      this.querySelectorAll("select"),
      (select) => select.value
    );
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);
    });
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    const mediaGalleries = document.querySelectorAll(
      `[id^="MediaGallery-${this.dataset.section}"]`
    );
    mediaGalleries.forEach((mediaGallery) =>
      mediaGallery.setActiveMedia(
        `${this.dataset.section}-${this.currentVariant.featured_media.id}`,
        true
      )
    );

    const modalContent = document.querySelector(
      `#ProductModal-${this.dataset.section} .product-media-modal__content`
    );
    if (!modalContent) return;
    const newMediaModal = modalContent.querySelector(
      `[data-media-id="${this.currentVariant.featured_media.id}"]`
    );
    modalContent.prepend(newMediaModal);
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === "false") return;
    window.history.replaceState(
      {},
      "",
      `${this.dataset.url}?variant=${this.currentVariant.id}`
    );
  }

  updateShareUrl() {
    const shareButton = document.getElementById(
      `Share-${this.dataset.section}`
    );
    if (!shareButton || !shareButton.updateUrl) return;
    shareButton.updateUrl(
      `${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`
    );
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(
      `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`
    );
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event("change", { bubbles: true }));
    });
  }

  updateVariantStatuses() {
  const checkedInput = this.querySelector(".fieldset-color input[type=radio]:checked");
  const selectedOptionOneVariants = checkedInput
    ? this.variantData.filter((variant) => checkedInput.value === variant.option1)
    : this.variantData;
  const inputWrappers = [...this.querySelectorAll(".product-form__input")];
  inputWrappers.forEach((option, index) => {
    if (index === 0) return;
    const optionInputs = [
      ...option.querySelectorAll('input[type="radio"], option'),
    ];
    const previousOptionSelected =
      inputWrappers[index - 1].querySelector(":checked")?.value || "";
    const availableOptionInputsValue = selectedOptionOneVariants
      .filter(
        (variant) =>
          variant.available &&
          variant[`option${index}`] === previousOptionSelected
      )
      .map((variantOption) => variantOption[`option${index + 1}`]);
    this.setInputAvailability(optionInputs, availableOptionInputsValue);
  });
}


  setInputAvailability(listOfOptions, listOfAvailableOptions) {
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector("pickup-availability");
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute("available");
      pickUpAvailability.innerHTML = "";
    }
  }

  removeErrorMessage() {
    const section = this.closest("section");
    if (!section) return;

    const productForm = section.querySelector("product-form");
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    const requestedVariantId = this.currentVariant.id;
    const sectionId = this.dataset.originalSection
      ? this.dataset.originalSection
      : this.dataset.section;

    let fetchSection = this.dataset.section.replace("-pdf", "");

    fetch(
      `${this.dataset.url}?variant=${requestedVariantId}&section_id=${
        this.dataset.originalSection
          ? this.dataset.originalSection
          : fetchSection
      }`
    )
      .then((response) => response.text())
      .then((responseText) => {
        // prevent unnecessary ui changes from abandoned selections
        if (this.currentVariant.id !== requestedVariantId) return;

        const html = new DOMParser().parseFromString(responseText, "text/html");
        const destination = document.getElementById(
          `price-${this.dataset.section}`
        );
        const source = html.getElementById(
          `price-${
            this.dataset.originalSection
              ? this.dataset.originalSection
              : this.dataset.section
          }`
        );
        const skuSource = html.getElementById(
          `Sku-${
            this.dataset.originalSection
              ? this.dataset.originalSection
              : this.dataset.section
          }`
        );
        const skuDestination = document.getElementById(
          `Sku-${this.dataset.section}`
        );
        const inventorySource = html.getElementById(
          `Inventory-${
            this.dataset.originalSection
              ? this.dataset.originalSection
              : this.dataset.section
          }`
        );
        const inventoryDestination = document.getElementById(
          `Inventory-${this.dataset.section}`
        );

        if (source && destination) destination.innerHTML = source.innerHTML;
        if (inventorySource && inventoryDestination)
          inventoryDestination.innerHTML = inventorySource.innerHTML;
        if (skuSource && skuDestination) {
          skuDestination.innerHTML = skuSource.innerHTML;
          skuDestination.classList.toggle(
            "visibility-hidden",
            skuSource.classList.contains("visibility-hidden")
          );
        }

        const price = document.getElementById(`price-${this.dataset.section}`);

        if (price) price.classList.remove("visibility-hidden");

        if (inventoryDestination)
          inventoryDestination.classList.toggle(
            "visibility-hidden",
            inventorySource.innerText === ""
          );

        const addButtonUpdated = html.getElementById(
          `ProductSubmitButton-${sectionId}`
        );
        this.toggleAddButton(
          addButtonUpdated ? addButtonUpdated.hasAttribute("disabled") : true,
          window.variantStrings.soldOut
        );

        const skuElement = document.querySelector(
          '.rocket-scalpers-main-product__sku-wrapper__sku__value'
        );
        if (skuElement && this.currentVariant && this.currentVariant.sku) {
          skuElement.textContent = this.currentVariant.sku;
        }

        publish(PUB_SUB_EVENTS.variantChange, {
          data: {
            sectionId,
            html,
            variant: this.currentVariant,
          },
        });
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(
      `product-form-${this.dataset.section}`
    );
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');
    if (!addButton) return;

    if (disable) {
      addButton.setAttribute("disabled", "disabled");
      if (text) addButtonText.textContent = text;
    } else {
      addButton.removeAttribute("disabled");
      addButtonText.textContent = window.variantStrings.addToCart;
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button =
      document.getElementById(`product-form-${this.dataset.section}`) ||
      document.getElementById(`product-form-${this.dataset.product}`);
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    const inventory = document.getElementById(
      `Inventory-${this.dataset.section}`
    );
    const sku = document.getElementById(`Sku-${this.dataset.section}`);

    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add("visibility-hidden");
    if (inventory) inventory.classList.add("visibility-hidden");
    if (sku) sku.classList.add("visibility-hidden");
  }

  getVariantData() {
    this.variantData =
      this.variantData ||
      JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define("variant-selects", VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach((input) => {
      if (listOfAvailableOptions.includes(input.getAttribute("value"))) {
        // input.classList.remove("disabled");
      } else {
        // input.classList.add("disabled");
      }
    });
  }

 updateOptions() {
  const fieldsets = Array.from(this.querySelectorAll("fieldset"));
  this.options = fieldsets.map((fieldset) => {
    const selected = Array.from(fieldset.querySelectorAll("input")).find(
      (radio) => radio.checked
    );

    // Si no hay ninguno marcado, intenta coger el primero disponible
    if (!selected) {
      const firstAvailable = Array.from(fieldset.querySelectorAll("input")).find(
        (radio) => !radio.classList.contains("disabled")
      );
      return firstAvailable ? firstAvailable.value : null;
    }

    return selected.value;
  });
}


}

customElements.define("variant-radios", VariantRadios);

class ProductRecommendations extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      fetch(this.dataset.url)
        .then((response) => response.text())
        .then((text) => {
          const html = document.createElement("div");
          html.innerHTML = text;
          const recommendations = html.querySelector("product-recommendations");

          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML;
          }

          if (
            !this.querySelector("slideshow-component") &&
            this.classList.contains("complementary-products")
          ) {
            this.remove();
          }

          if (html.querySelector(".grid__item")) {
            this.classList.add("product-recommendations--loaded");
          }
        })
        .catch((e) => {
          console.error(e);
        });
    };

    new IntersectionObserver(handleIntersection.bind(this), {
      rootMargin: "0px 0px 400px 0px",
    }).observe(this);
  }
}

customElements.define("product-recommendations", ProductRecommendations);

class VariantSwiper extends HTMLElement {
  constructor() {
    super();
    this.dummySizeSelector = document.querySelector(
      ".cart-drawer__size-selector-mb"
    );
    this.dummyOverlay = document.querySelector(
      ".cart-drawer__size-selector-mb .rocket-scalpers-product-card__overlay"
    );
    this.isPDP = this.closest("drag-product-info");
    this.isPDP = this.closest("list-dragging") ? null : this.isPDP;
    this.isAccordion = this.closest("list-dragging");
    this.slider = this.querySelector(
      ".card-variant-container  .swiper-wrapper"
    );
    this.sliderItems = this.querySelectorAll(".swiper-slide");
  }
  init() {
    if (this.initiated) return;
    this.initiated = true;
    let optionList = this.querySelectorAll(
      "card-variant-radios .product-form__input input[name='size']"
    );

    if (
      (!this.isPDP && optionList.length > 4) ||
      (this.isPDP && optionList.length > 6) ||
      (this.isAccordion && optionList.length > 3)
    ) {
      let selector = "#" + this.id + " card-variant-radios";
      this.nextBtn = this.querySelector(".variant-swiper-button-next");
      this.prevBtn = this.querySelector(".variant-swiper-button-prev");
      this.nextBtn.classList.remove("visually-hidden");
      this.prevBtn.classList.remove("visually-hidden");
      let slidesPerViewOption = this.isPDP ? 6 : 4;
      if (this.isAccordion) {
        slidesPerViewOption = 3;
      }
      this.prevBtn.addEventListener("click", this.onButtonClick.bind(this));
      this.nextBtn.addEventListener("click", this.onButtonClick.bind(this));
      this.slider.addEventListener("scroll", this.update.bind(this));

      // this.swiper = new Swiper(selector, {
      //   slidesPerView: slidesPerViewOption,
      //   allowTouchMove: false,
      //   navigation: {
      //     nextEl: "#" + this.id + ' .variant-swiper-button-next',
      //     prevEl: "#" + this.id + ' .variant-swiper-button-prev'
      //   }
      // })

      this.initPages();
    } else {
      this.querySelectorAll(".swiper-slide").forEach((el) => {
        if (this.querySelector("fieldset.fieldset-active")) {
          this.querySelector("fieldset.fieldset-active").classList.add(
            "swiper-inactive-mb"
          );
        }
        this.classList.add("rocket-scalpers-product-card_radius");
        if (
          optionList.length == 1 &&
          this.querySelector("fieldset.fieldset-active")
        ) {
          this.querySelector("fieldset.fieldset-active").classList.add(
            "swiper-only-one-option"
          );
        }
      });
      if (this.isPDP && optionList.length < 6) {
        let inactiveClass =
          optionList.length == 5
            ? "swiper-container-inactive-5"
            : "swiper-container-inactive-4";
        if (this.querySelector("card-variant-radios")) {
          this.querySelector("card-variant-radios").classList.add(
            inactiveClass
          );
        }
      }
    }

    // add close popup event if dummy selector
    if (this.closest(".cart-drawer__size-selector-mb")) {
      this.querySelector(
        ".rocket-scalpers-product-card__size-close"
      ).addEventListener("click", () => {
        this.closeModal();
      });
    }
    this.querySelector('.rocket-scalpers-product-card__size-guide').addEventListener("click", () => {
      this.openSizeGuide();
    })
  }
  closeModal() {
    document.querySelector("body").style.overflowY = "unset";
    if (this.dummyOverlay) {
      this.dummyOverlay.style.display = "none";
    }
    document.querySelectorAll("variant-swiper").forEach((el) => {
      el.classList.remove("open");
    });
    if (document.querySelector(".rocket-scalpers-product-card__overlay")) {
      document
        .querySelectorAll(".rocket-scalpers-product-card__overlay")
        .forEach((overlay) => {
          overlay.style.display = "none";
        });
    }
  }
  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter(
      (element) => element.clientWidth > 0
    );
    if (this.sliderItemsToShow.length < 2) return;
    this.sliderItemOffset =
      this.sliderItemsToShow[1].offsetLeft -
      this.sliderItemsToShow[0].offsetLeft;
    this.slidesPerPage = Math.floor(
      (this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) /
        this.sliderItemOffset
    );
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }
  onButtonClick(event) {
    event.stopPropagation();
    event.preventDefault();
    if (!this.sliderItemOffset) {
      this.initPages();
    }
    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition = event.currentTarget.classList.contains(
      "variant-swiper-button-next"
    )
      ? this.slider.scrollLeft + step * this.sliderItemOffset
      : this.slider.scrollLeft - step * this.sliderItemOffset;
    //console.log(this.slideScrollPosition, step , this.slider.scrollLeft , this.sliderItemOffset);

    this.slider.scrollTo({
      left: this.slideScrollPosition,
      behavior: "smooth",
    });
  }
  update() {
    if (!this.slider || !this.nextButton) return;

    const previousPage = this.currentPage;
    this.currentPage =
      Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (
      this.isSlideVisible(this.sliderItemsToShow[0]) &&
      this.slider.scrollLeft === 0
    ) {
      this.prevButton.setAttribute("disabled", "disabled");
    } else {
      this.prevButton.removeAttribute("disabled");
    }

    if (
      this.isSlideVisible(
        this.sliderItemsToShow[this.sliderItemsToShow.length - 1]
      )
    ) {
      this.nextButton.setAttribute("disabled", "disabled");
    } else {
      this.nextButton.removeAttribute("disabled");
    }
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide =
      this.slider.clientWidth + this.slider.scrollLeft - offset;
    return (
      element.offsetLeft + element.clientWidth <= lastVisibleSlide &&
      element.offsetLeft >= this.slider.scrollLeft
    );
  }
  getSizeDrawer(){
    let url = `${this.dataset.productUrl}?section_id=main-product`;
    fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, "text/html");
        const sizeDrawer = html.querySelector("size-guide-drawer");
        if(sizeDrawer){
          const productInfo = document.createElement("div")
          productInfo.classList.add("hidden") ;
          productInfo.innerHTML = html.querySelector(`.rocket-scalpers-pdf-sticky__container`).innerHTML;
          document.querySelector("body").appendChild(productInfo);
          document.querySelector("body").appendChild(sizeDrawer);
          const productId = this.dataset.productId;
          const sizeGuide = document.querySelector(`#size-guide-${productId}`);
        
          sizeDrawer.section = productInfo
          if(sizeGuide){
            sizeGuide.trackButtonSubmit()
            sizeGuide.show();
            
          }
        }
      });
  }
  openSizeGuide(){
    const productId = this.dataset.productId;
    const sizeGuide = document.querySelector(`#size-guide-${productId}`);
    if(sizeGuide){
      sizeGuide.show();
    }else{
      this.getSizeDrawer()
    }
  }
}

customElements.define("variant-swiper", VariantSwiper);

class CardVariantRadios extends VariantRadios {
  constructor() {
    super();
    this.isQuickAddInPdp = this.closest("product-info");
    this.isQuickAddInPdp = this.closest("list-dragging")
      ? null
      : this.isQuickAddInPdp;
    this.cartDrawer = document.querySelector("cart-drawer");
    this.addEventListener("mousedown", (event) => {
      event.stopPropagation();
    });
  }

  onVariantChange(event) {
    if (event.target && event.target.getAttribute("name") == "color") {
      return;
    }
    if (this.isQuickAddInPdp) {
      this.cartDrawer.setAttribute("added-open-cart", "false");
    }
    this.setDefaultColor();
    this.updateOptions();
    this.updateMasterId();
    this.updateVariantInput();
    this.submitCart();
    this.resetSizeCheck();
    if (screen.width < 1024) {
      let productCardEl =
        this.closest("product-card") || this.closest("drag-product-info");
      if (productCardEl) {
        productCardEl.closeModal();
      }
    }
    this.closeInterested();
  }

  setDefaultColor() {
    let checkedInput = this.querySelector(
      "fieldset.fieldset-color input[type=radio]:checked"
    );
    if (!checkedInput) {
      let firstColorInput = this.querySelector(
        "fieldset.fieldset-color input[type=radio]"
      );
      if (firstColorInput) {
        firstColorInput.checked = true;
      }
    }
  }

  resetSizeCheck() {
    const fieldsets = this.querySelectorAll("fieldset.fieldset-active input");
    fieldsets.forEach((el) => {
      el.checked = false;
    });
  }

  submitCart() {
    const addToCartBtn = this.querySelector("button[name='add']");
    addToCartBtn.click();
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(
      `#product-form-${this.dataset.section}-${this.dataset.product},#product-form-${this.dataset.section}-${this.dataset.product}-${this.dataset.vendor}`
    );
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
    });
  }
  closeInterested() {
    let isInterested = this.closest("product-interested");
    if (isInterested) {
      document.querySelector("cart-drawer").open();
    }
  }
}

customElements.define("card-variant-radios", CardVariantRadios);

class ProductCard extends HTMLElement {
  constructor() {
    super();
    this.openCartBtn = this.querySelector(
      ".rocket-scalpers-product-card__btn-cart"
    );
    this.sizeSelector = this.querySelector("variant-swiper");
    this.closeCartBtn = this.querySelector(
      ".rocket-scalpers-product-card__size-close"
    );
    this.overlay = this.querySelector(".rocket-scalpers-product-card__overlay");
    this.specialProduct =
      this.closest(".rocket-scalpers--special-products") ||
      this.closest("special-products-cards");
    this.drawerProductsSlider = this.closest("drawer-products-slider");
    this.drawerProductsSlider_Product = this.closest(
      "drawer-products-slider-product"
    );
    this.drawerProductsSlider_Product_rlp = this.closest(
      "drawer-products-slider-product-rlp"
    );
    this.dummySizeSelector = document.querySelector(
      ".cart-drawer__size-selector-mb"
    );
    this.productSizeSelector = document.querySelector(
      ".carousel-ctl__size-selector-mb"
    );
    this.productSizeSelector_rlp = document.querySelector(
      ".carousel-rlp__size-selector-mb"
    );
    this.dummyOverlay = document.querySelector(
      ".cart-drawer__size-selector-mb .rocket-scalpers-product-card__overlay"
    );
    this.productOverlay = document.querySelector(
      ".carousel-ctl__size-selector-mb .rocket-scalpers-product-card__overlay"
    );
    this.productOverlay_rlp = document.querySelector(
      ".carousel-rlp__size-selector-mb .rocket-scalpers-product-card__overlay"
    );
    this.observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            this.convertImageSrc();

            this.initEvents();
            this.observer.disconnect();
          }
        });
      },
      { rootMargin: "0px 0px 200px 0px" }
    );
    this.observer.observe(this);
  }
  convertImageSrc() {
    const images = this.querySelectorAll("img");
    let width = this.offsetWidth;
    if (width == 0) return;
    const query =
      "(-webkit-min-device-pixel-ratio: 2), (min-device-pixel-ratio: 2), (min-resolution: 192dpi)";
    if (matchMedia(query).matches) {
      width = width * 2;
    } else {
      width = width * 1.5;
    }
    images.forEach((image) => {
      let src = image.src.split("&")[0] + "&width=" + Math.floor(width);
      image.srcset = src;
      /*          if(!image.classList.value.includes("rr-invited")) {
           image.style.opacity = '1';
         } */
    });
  }
  initEvents() {
    let optionList = this.querySelectorAll(
      "card-variant-radios .product-form__input input[name='size']"
    );
    if (this.openCartBtn) {
      this.openCartBtn.addEventListener("click", () => {
        if (
          this.closest(
            ".rocket-scalpers-home-stl__wrapper__item__popup__wrapper__content__products__wrappers"
          )
        ) {
          this.openCustomMb_product(
            this.openCartBtn.getAttribute("data-product-id")
          );
          if (optionList.length > 1) {
            this.dummySizeSelectorHome = document.querySelector(
              `.carousel-ctl__size-selector-mb-${this.openCartBtn.getAttribute(
                "data-section-id"
              )}`
            );
            this.dummySizeSelectorHome.style.display = "block";
            document
              .querySelector(
                `.rocket-scalpers-product-card__overlay-carousel-${this.openCartBtn.getAttribute(
                  "data-section-id"
                )}`
              )
              .addEventListener("click", () => {
                this.closeModal(
                  this.openCartBtn.getAttribute("data-product-id")
                );
                this.dummySizeSelectorHome.style.display = "none";
                document.querySelector(
                  ".rocket-scalpers-product-card__overlay-carousel"
                ).style.display = "none";
                document
                  .querySelectorAll(
                    ".carousel-rlp__size-selector-mb .rocket-scalpers-product-card__overlay"
                  )
                  .forEach((x) => (x.style.display = "none"));
                document
                  .querySelectorAll(
                    ".carousel-rlp__size-selector-mb .rocket-scalpers-product-card__quick-add"
                  )
                  .forEach((item) => {
                    item.classList.remove("open");
                  });
              });
          }
        }
        document.querySelector("body").style.overflowY = "hidden";
        if (document.querySelector("drag-product-info")) {
          document.querySelector("drag-product-info").style.overflowY =
            "hidden";
        }
        if (this.closest("section")) {
          this.closest("section").classList.add("z-index-10");
          if (this.specialProduct || this.closest("special-products-cards")) {
            this.closest("section").classList.add("openCartBtn");
            if (
              document.querySelector(".rocket-header__heading__mobile") != null
            )
              document
                .querySelector(".rocket-header__heading__mobile")
                .classList.add("z-index-1");
          }
          document
            .querySelectorAll(".rocket-scalpers--special-products")
            .forEach((x) => {
              if (x != this.closest("section")) {
                x.classList.add("z-index-0");
              }
            });
        }
        if (optionList.length == 1) {
          optionList.forEach((el) => {
            el.click();
          });
          return;
        }
        if (this.drawerProductsSlider) {
          this.openCustomMb(this.openCartBtn.getAttribute("data-product-id"));
        } else if (this.drawerProductsSlider_Product) {
          this.openCustomMb_product(
            this.openCartBtn.getAttribute("data-product-id")
          );
        } else if (
          this.drawerProductsSlider_Product_rlp ||
          this.specialProduct ||
          this.closest("special-products-cards")
        ) {
          this.openCustomMb_product_rlp(
            this.openCartBtn.getAttribute("data-product-id")
          );
        } else {
          this.overlay.style.display = "block";
          this.sizeSelector.classList.add("open");
        }
      });
    }
    if (this.overlay) {
      this.overlay.addEventListener("click", () => {
        this.closeModal(this.openCartBtn.getAttribute("data-product-id"));
        this.closest("section").classList.remove("openCartBtn");
        if (document.querySelector(".rocket-header__heading__mobile") != null)
          document
            .querySelector(".rocket-header__heading__mobile")
            .classList.remove("z-index-1");
        document
          .querySelectorAll(".rocket-scalpers--special-products")
          .forEach((x) => x.classList.remove("z-index-0"));
      });
    }
    if (this.productOverlay) {
      this.productOverlay.addEventListener("click", () => {
        this.closeModal(this.openCartBtn.getAttribute("data-product-id"));
      });
      if (this.closest("section")) {
        this.closest("section").classList.remove("z-index-10");
      }
    }
    if (this.productOverlay_rlp) {
      this.productOverlay_rlp.addEventListener("click", () => {
        this.closeModal(this.openCartBtn.getAttribute("data-product-id"));
      });
      if (this.closest(".rocket-scalpers--special-products")) {
        this.closest("section")
          .querySelector(
            ".carousel-rlp__size-selector-mb .rocket-scalpers-product-card__overlay"
          )
          .addEventListener("click", () => {
            this.closeModal(this.openCartBtn.getAttribute("data-product-id"));
          });
      }
      if (this.closest("section")) {
        this.closest("section").classList.remove("z-index-10");
      }
    }
    if (this.dummyOverlay) {
      this.dummyOverlay.addEventListener("click", () => {
        this.closeModal(this.openCartBtn.getAttribute("data-product-id"));
      });
    }
    if (this.closeCartBtn) {
      this.closeCartBtn.addEventListener("click", () => {
        this.closeModal(this.openCartBtn.getAttribute("data-product-id"));
        if (this.closest("section")) {
          this.closest("section").classList.remove("z-index-10");
          this.closest("section").classList.remove("openCartBtn");
          if (document.querySelector(".rocket-header__heading__mobile") != null)
            document
              .querySelector(".rocket-header__heading__mobile")
              .classList.remove("z-index-1");
          document
            .querySelectorAll(".rocket-scalpers--special-products")
            .forEach((x) => x.classList.remove("z-index-0"));
        }
      });
    }
    this.addEventListener("touchstart", (e) => {
      this.querySelector("variant-swiper").init();
    });
    this.addEventListener("mouseenter", () => {
      this.querySelector("variant-swiper").init();
    });
    window.addEventListener("resize", () => {
      this.convertImageSrc();
    });
  }
  openCustomMb(productId) {
    if (this.dummyOverlay) {
      this.dummyOverlay.style.display = "block";
    }
    if (
      this.dummySizeSelector.querySelector(
        "[data-product-id='" + productId + "']"
      )
    ) {
      this.dummySizeSelector
        .querySelector("[data-product-id='" + productId + "']")
        .classList.add("open");
    }
  }

  openCustomMb_product(productId) {
    if (this.productOverlay) {
      document
        .querySelectorAll(".rocket-scalpers-product-card__overlay")
        .forEach((item) => {
          item.style.display = "none";
        });
      if (
        this.closest(
          ".rocket-scalpers-home-stl__wrapper__item__popup__wrapper__content__products__wrappers"
        )
      ) {
        document.querySelector(
          `.rocket-scalpers-product-card__overlay-carousel-${this.openCartBtn.getAttribute(
            "data-section-id"
          )}`
        ).style.display = "block";
      } else {
        this.productOverlay.style.display = "block";
      }
    }
    if (this.productSizeSelector) {
      if (
        this.productSizeSelector.querySelector(
          "[data-product-id='" + productId + "']"
        )
      ) {
        this.productSizeSelector
          .querySelector("[data-product-id='" + productId + "']")
          .classList.add("open");
      } else {
        document
          .querySelector(
            `.carousel-ctl__size-selector-mb-${this.openCartBtn.getAttribute(
              "data-section-id"
            )}`
          )
          .querySelector("[data-product-id='" + productId + "']")
          ?.classList.add("open");
      }
    }
  }

  openCustomMb_product_rlp(productId) {
    if (
      this.productOverlay_rlp &&
      this.closest(".rocket-scalpers--special-products") == null
    ) {
      document
        .querySelectorAll(".rocket-scalpers-product-card__overlay")
        .forEach((item) => {
          item.style.display = "none";
        });
      this.productOverlay_rlp.style.display = "block";
    }

    if (this.productSizeSelector_rlp) {
      if (
        this.productSizeSelector_rlp.querySelector(
          "[data-product-id='" + productId + "']"
        )
      ) {
        this.productSizeSelector_rlp
          .querySelector("[data-product-id='" + productId + "']")
          .classList.add("open");
      }
    }
    if (this.closest(".rocket-scalpers--special-products")) {
      this.closest("section").querySelector(
        ".carousel-rlp__size-selector-mb .rocket-scalpers-product-card__overlay"
      ).style.display = "block";
      if (
        this.closest("section").querySelector(".carousel-rlp__size-selector-mb")
      ) {
        this.closest("section")
          .querySelector(".carousel-rlp__size-selector-mb")
          .querySelector("[data-product-id='" + productId + "']")
          .classList.add("open");
        this.closest("section")
          .querySelectorAll(".carousel-rlp__size-selector-mb variant-swiper")
          .forEach((el) => el.init());
      }
    }
  }

  closeModal(productId) {
    if (
      this.closest(
        ".rocket-scalpers-home-stl__wrapper__item__popup__wrapper__content__products__wrappers"
      )
    ) {
      this.productSizeSelector
        .querySelectorAll(".rocket-scalpers-product-card__quick-add")
        .forEach((item) => {
          item.classList.remove("open");
        });
    }
    document.querySelector("body").style.overflowY = "unset";
    if (document.querySelector("drag-product-info")) {
      document.querySelector("drag-product-info").style.overflowY = "visible";
    }
    if (this.drawerProductsSlider) {
      this.dummyOverlay.style.display = "none";
      if (
        this.dummySizeSelector.querySelector(
          "[data-product-id='" + productId + "']"
        )
      ) {
        this.dummySizeSelector
          .querySelector("[data-product-id='" + productId + "']")
          .classList.remove("open");
      }
    } else {
      this.overlay.style.display = "none";
      document
        .querySelectorAll(
          ".carousel-rlp__size-selector-mb .rocket-scalpers-product-card__overlay"
        )
        .forEach((x) => (x.style.display = "none"));
      document
        .querySelectorAll(
          ".carousel-rlp__size-selector-mb .rocket-scalpers-product-card__quick-add"
        )
        .forEach((item) => {
          item.classList.remove("open");
        });
      if (this.closest("section")) {
        this.closest("section").classList.remove("z-index-10");
      }
      this.sizeSelector.classList.remove("open");
    }
    if (this.drawerProductsSlider_Product) {
      if (this.productOverlay) {
        this.productOverlay.style.display = "none";
      }
      if (this.productSizeSelector) {
        this.productSizeSelector
          .querySelectorAll(".rocket-scalpers-product-card__quick-add")
          .forEach((item) => {
            item.classList.remove("open");
          });
      }
      if (this.closest("section")) {
        this.closest("section").classList.remove("z-index-10");
      }
    }
    if (this.drawerProductsSlider_Product_rlp) {
      if (this.productOverlay_rlp) {
        this.productOverlay_rlp.style.display = "none";
      }
      if (this.productSizeSelector_rlp) {
        this.productSizeSelector_rlp
          .querySelectorAll(".rocket-scalpers-product-card__quick-add")
          .forEach((item) => {
            item.classList.remove("open");
          });
      }
      if (this.closest("section")) {
        this.closest("section").classList.remove("z-index-10");
      }
    }
  }
}

customElements.define("product-card", ProductCard);

class DrawerProductsSlider extends HTMLElement {
  constructor() {
    super();
    var slidesPerView = null;
    if (screen.width >= 768) {
      slidesPerView = "auto";
    } else {
      slidesPerView = 2;
    }
    this.swiper = new Swiper("drawer-products-slider", {
      slidesPerView: slidesPerView,
      navigation: {
        nextEl:
          "drawer-products-slider .cart-drawer__products-slider-heading--btn-next",
        prevEl:
          "drawer-products-slider .cart-drawer__products-slider-heading--btn-prev",
      },
    });
  }
}

customElements.define("drawer-products-slider", DrawerProductsSlider);

class ProductInterested extends HTMLElement {
  constructor() {
    super();
    this.closeBtn = this.querySelector(
      ".rocket-scalpers-product-interested_close-btn"
    );
    this.overlay = document.querySelector("#product-interested-overlay");
    this.section = this.closest(".rocket-scalpers-product-interested");
    this.viewCart = this.querySelector(
      ".rocket-scalpers-product-interested_view-cart"
    );
    this.cartDrawer = document.querySelector("cart-drawer");
    this.body = document.querySelector("body");
    this.overlay.addEventListener("click", () => {
      this.inactivate();
      // BackToSkull24();
      // AddOpiMum24();
      // Halloween24();
    });
    this.closeBtn.addEventListener("click", () => {
      this.inactivate();
      // BackToSkull24();
      // AddOpiMum24();
      // Halloween24();
    });
    this.viewCart.addEventListener("click", () => {
      this.inactivate();
      this.cartDrawer.open();
      // BackToSkull24();
      // AddOpiMum24();
      // Halloween24();
    });
    document.addEventListener("listencart", () => {
      // BackToSkull24();
      // AddOpiMum24();
      // Halloween24();
    });
  }
  activate() {
    // this.section.classList.add("open");
    this.classList.add("open");
    this.body.style.overflowY = "hidden";
    document.querySelectorAll("variant-swiper").forEach((variant) => {
      variant.closeModal();
    });
  }
  inactivate() {
    this.section.classList.remove("open");
    this.classList.remove("open");
    this.body.style.overflowY = "unset";
  }
}

customElements.define("product-interested", ProductInterested);

class PriceInfo extends HTMLElement {
  constructor() {
    super();
    this.closeBtn = this.querySelector(".price-info-popup__close");
    this.openBtn = this.querySelector(".price-info-icon");
    this.popup = this.querySelector(".price-info-popup");
    this.priceWrapper =
      this.closest(".drawer__cart-items-item--info-price-wrapper") ??
      this.closest(".rocket-scalpers-main-product__price-wrapper");
    this.querySelector(".price-info-popup").addEventListener(
      "click",
      (event) => {
        event.stopPropagation();
      }
    );

    this.openBtn.addEventListener("click", (event) => {
      event.stopPropagation();
      this.closeOpenedPopup();
      this.popup.classList.contains("open")
        ? this.closePopup()
        : this.openPopup();
    });
    this.closeBtn.addEventListener("click", (event) => {
      event.stopPropagation();
      this.closePopup();
    });
  }
  openPopup() {
    this.popup.classList.add("open");
  }
  closePopup() {
    this.popup.classList.remove("open");
  }
  closeOpenedPopup() {
    let openedPriceInfoEl = document.querySelector(
      "price-info .price-info-popup.open"
    );
    if (openedPriceInfoEl) {
      openedPriceInfoEl.classList.remove("open");
    }
  }
}

customElements.define("price-info", PriceInfo);
class AccordionTab extends HTMLElement {
  constructor() {
    super();

    this.details = this.querySelector("details");
    this.summary = this.querySelector("summary");
    this.content = this.querySelector(".accordion__content");

    this.animation = null;
    this.isClosing = false;
    this.isExpanding = false;
    this.summary.addEventListener("click", (e) => this.onClick(e));
  }

  onClick(e) {
    e.preventDefault();

    this.details.style.overflow = "hidden";
    if (this.isClosing || !this.details.open) {
      this.open();
    } else if (this.isExpanding || this.details.open) {
      this.shrink();
    }
  }

  shrink() {
    this.isClosing = true;

    const summaryStyle = window.getComputedStyle(this.summary);
    const startHeight = `${this.details.offsetHeight}px`;
    const endHeight = `${
      this.summary.offsetHeight + parseInt(summaryStyle.marginTop)
    }px`;

    if (this.animation) {
      this.animation.cancel();
    }

    this.animation = this.details.animate(
      {
        height: [startHeight, endHeight],
      },
      {
        duration: 250,
        easing: "ease-in-out",
      }
    );

    this.details.open = false;

    this.animation.onfinish = () => this.onAnimationFinish(false);
    this.animation.oncancel = () => (this.isClosing = false);
  }

  open() {
    this.details.style.height = `${this.details.offsetHeight}px`;
    this.details.open = true;
    window.requestAnimationFrame(() => this.expand());
  }

  expand() {
    this.isExpanding = true;

    const summaryStyle = window.getComputedStyle(this.summary);
    const startHeight = `${this.details.offsetHeight}px`;
    const endHeight = `${
      this.summary.offsetHeight +
      parseInt(summaryStyle.marginTop) +
      this.content.offsetHeight
    }px`;

    if (this.animation) {
      this.animation.cancel();
    }

    this.animation = this.details.animate(
      {
        height: [startHeight, endHeight],
      },
      {
        duration: 400,
        easing: "ease-in-out",
      }
    );

    this.animation.onfinish = () => this.onAnimationFinish(true);
    this.animation.oncancel = () => (this.isExpanding = false);
  }

  onAnimationFinish(open) {
    this.details.open = open;
    this.animation = null;
    this.isClosing = false;
    this.isExpanding = false;
    this.details.style.height = this.details.style.overflow = "";
  }
}
customElements.define("accordion-tab", AccordionTab);

class FAQGrouping extends HTMLElement {
  constructor() {
    super();

    var faqGroupingInner = document.createElement("div");
    faqGroupingInner.classList.add("faq-grouping-inner");

    var details = document.querySelectorAll(
      "section:not(.faq-grouping).faq-section-grouping"
    );

    details.forEach((detail) => {
      faqGroupingInner.appendChild(detail.cloneNode(true));
      detail.remove();
    });

    this.parentEle = this.closest("#MainContent");

    var faqGroupingElement = this.parentEle.querySelector(".faq-grouping");

    if (faqGroupingElement) {
      faqGroupingElement.parentNode.insertBefore(
        faqGroupingInner,
        faqGroupingElement.nextSibling
      );
    } else {
      this.parentEle.appendChild(faqGroupingInner);
    }
  }
}

customElements.define("faq-grouping", FAQGrouping);

function toggleVer(btn, TextVerLess, TextVerMore) {
  var ToggleWrapper = btn.closest("faq-section");
  if (ToggleWrapper) {
    if (ToggleWrapper.classList.contains("vermore")) {
      ToggleWrapper.classList.remove("vermore");
      btn.innerText = TextVerMore;
    } else {
      ToggleWrapper.classList.add("vermore");
      btn.innerText = TextVerLess;
    }
  }
}

class ScalpersSliderComponent extends HTMLElement {
  constructor() {
    super();
    this.currentPageIndex = document.querySelector(
      ".rocket-scalpers-product-media-gallery .rocket-scalpers-pagination .rocket-scalpers-pagination__current"
    );
    if (screen.width > 1023) {
      this.swiper = new Swiper(this, {
        direction: "vertical",
        slidesPerView: "auto",
        centeredSlides: false,
        mousewheel: {
          releaseOnEdges: true,
        },
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
          draggable: true,
        },
        scrollbar: {
          el: ".swiper-scrollbar",
          draggable: true,
        },
      });
      this.swiper.on("slideChange", () => {
        this.currentPageIndex.innerText = this.swiper.activeIndex + 1;
      });
    }
  }
}

customElements.define("scalpers-slider-component", ScalpersSliderComponent);
class ProductVariantRadius extends VariantRadios {
  constructor() {
    super();
    this.colorTextEl = this.querySelector(
      ".rocket-scalpers-main-product__variant-color-text-selected"
    );
    this.hasColorSelector = this.getColorSelected();
    this.colorIsFirstOption = this.checkColorIsFirstOption();
    this.colorPicker = document.querySelector(
      "drag-product-info .rocket-scalpers-main-product__title-color-picker .rocket-scalpers-main-product__color-cube"
    );
    this.quickAddFormId = `product-form-${this.dataset.section}-${this.dataset.product}`;
  }
  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, "", false);
    this.updatePickupAvailability();
    this.removeErrorMessage();
    this.updateVariantStatuses();
    // update color text
    if (this.hasColorSelector) {
      let colorValue = this.getColorSelected();
      this.colorTextEl.innerText = colorValue.value;
      this.updateSizeFieldset();
      this.updateColorPicker(colorValue.value);
      this.updateQuickAddForm(colorValue.value);
    }
    if (!this.currentVariant) {
      this.toggleAddButton(true, "", true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateSKU();
      this.updateShareUrl();
    }
  }
  updateSizeFieldset() {
    let sizeFieldsetEl =
      this.querySelector(".fieldset-size") ??
      this.querySelector(".fieldset-talla");
    let colorSelectedEl = this.getColorSelected();
    if (sizeFieldsetEl) {
      const sizeOptionAttr = this.colorIsFirstOption ? "option2" : "option1";
      const selectedOptionColorVariants = this.variantData.filter((variant) => {
        return this.colorIsFirstOption
          ? colorSelectedEl.value === variant.option1
          : colorSelectedEl.value === variant.option2;
      });
      const availableOptionInputsValue = selectedOptionColorVariants
        .filter((variant) => {
          return variant.available;
        })
        .map((variantOption) => {
          return variantOption[`${sizeOptionAttr}`];
        });
      sizeFieldsetEl.querySelectorAll("input").forEach((input) => {
        if (!availableOptionInputsValue.includes(input.value)) {
          input.classList.add("disabled");
        } else {
          input.classList.remove("disabled");
        }
      });
    }
  }
  getColorSelected() {
    return this.querySelector(".fieldset-color input[type=radio]:checked");
  }
  checkColorIsFirstOption() {
    let firstFieldset = this.querySelector(".product-form__input");
    return firstFieldset.classList.contains("fieldset-color");
  }
  getVariantJson() {
    let variantJsonEl = JSON.parse(
      this.querySelector('[data-json="variant"]').textContent
    );
    return variantJsonEl;
  }
  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;
    const mediaGalleries = document.querySelectorAll(
      `[id^="MediaGallery-${this.dataset.section}"] .product__media-list .product__media-item`
    );
    let imageEl = mediaGalleries[0].querySelector(".rocket-product-media img");
    imageEl.srcset = "";
    imageEl.src = this.currentVariant.featured_media.preview_image.src;
  }
  updateSKU() {
    if (!this.currentVariant) return;
    this.skuWrapper = document.querySelector(
      `#main-product-sku-${this.dataset.section}`
    );
    if (this.skuWrapper) {
      if (
        this.skuWrapper.querySelector(
          `.rocket-scalpers-main-product__sku-wrapper__sku__value`
        )
      ) {
        if (this.currentVariant.sku) {
          if (
            this.skuWrapper.querySelector(
              `.rocket-scalpers-main-product__sku-wrapper__ref`
            )
          ) {
            this.skuWrapper.querySelector(`.source`).classList.remove("hidden");
          }
          this.skuWrapper
            .querySelector(`.rocket-scalpers-main-product__sku-wrapper__sku`)
            .classList.remove("hidden");
          this.skuWrapper.querySelector(
            `.rocket-scalpers-main-product__sku-wrapper__sku__value`
          ).textContent = this.currentVariant.sku;
        } else {
          this.skuWrapper
            .querySelector(`.rocket-scalpers-main-product__sku-wrapper__sku`)
            .classList.add("hidden");
          if (this.skuWrapper.querySelector(`.source`)) {
            this.skuWrapper.querySelector(`.source`).classList.add("hidden");
          }
        }
      }
    }
  }
  updateColorPicker(colorText) {
    if (!this.colorPicker) return;
    let classList = this.colorPicker.getAttribute("class");
    let colorClass = colorText.toLowerCase().replace(" ", "");
    this.colorPicker.setAttribute(
      "class",
      classList.replace(
        /(^|\s)rocket-scalpers-product-card__swatch--\S+/g,
        " rocket-scalpers-product-card__swatch--" + colorClass + " "
      )
    );
  }
  updateQuickAddForm(colorText) {
    let colorInputEl = document.querySelector(
      `[form='${this.quickAddFormId}'][value='${colorText}']`
    );
    if (colorInputEl) {
      colorInputEl.click();
    }
  }
}

customElements.define("product-variant-radius", ProductVariantRadius);

class DragProductInfo extends HTMLElement {
  constructor() {
    super();
    this.dragItem = this.querySelector(".product__info-grabable-icon");
    this.productInfo = this;
    this.active = false;
    this.currentY = 0;
    this.initialY = 0;
    this.yOffset = 0;
    this.anadirBtn = this.querySelector(
      ".rocket-scalpers-main-product__buy-buttons-anadir"
    );
    this.sizeSelector = this.querySelector(
      ".rocket-scalpers-main-product__buy-buttons-wrapper variant-swiper"
    );
    this.overlay = this.querySelector(
      ".rocket-scalpers-main-product__buy-buttons-wrapper .rocket-scalpers-product-card__overlay"
    );
    this.closeCartBtn = this.querySelector(
      ".rocket-scalpers-main-product__buy-buttons-wrapper .rocket-scalpers-product-card__size-close"
    );
    this.titleEl =
      this.querySelector(
        ".rocket-scalpers-main-product__brand-image-wrapper"
      ) || this.querySelector(".rocket-scalpers-main-product__title-wrapper");
    this.scalpersSliderComponentEl = document.querySelector(
      "scalpers-slider-component"
    );
    this.cartDrawer = document.querySelector("cart-drawer");
    this.initEvents();
    let optionList = this.querySelectorAll(
      "card-variant-radios .product-form__input input[name='size']"
    );
    this.colorPickerEl = this.querySelector(
      ".rocket-scalpers-main-product__title-color-picker"
    );
    if (this.anadirBtn) {
      this.anadirBtn.addEventListener("click", () => {
        if (optionList.length == 1) {
          optionList.forEach((el) => {
            el.click();
          });
          return;
        } else if (optionList.length == 0) {
          document
            .querySelector(
              ".rocket-scalpers-main-product__buy-buttons-wrapper button.product-form__submit"
            )
            ?.click();
          this.cartDrawer.setAttribute("added-open-cart", "false");
          return;
        }
        document.querySelector("body").style.overflowY = "hidden";

        this.overlay.style.display = "block";
        this.sizeSelector.classList.add("open");
      });
    }

    this.overlay.addEventListener("click", () => {
      this.closeModal();
    });

    this.closeCartBtn.addEventListener("click", () => {
      this.closeModal();
    });
    if (this.colorPickerEl) {
      this.colorPickerEl.addEventListener("click", () => {
        this.classList.toggle("color-picker-toggled");
      });
    }
    this.querySelectorAll("variant-swiper").forEach((el) => el.init());
  }

  closeModal() {
    document.querySelector("body").style.overflowY = "unset";
    this.overlay.style.display = "none";
    this.sizeSelector.classList.remove("open");
  }

  initEvents() {
    this.dragItem.addEventListener(
      "touchstart",
      (event) => this.dragStart(event),
      false
    );
    this.dragItem.addEventListener(
      "touchend",
      (event) => this.dragEnd(),
      false
    );
    this.dragItem.addEventListener(
      "touchmove",
      (event) => this.dragMove(event),
      false
    );

    this.dragItem.addEventListener(
      "mousedown",
      (event) => this.dragStart(event),
      false
    );
    this.dragItem.addEventListener("mouseup", (event) => this.dragEnd(), false);
    this.dragItem.addEventListener(
      "mousemove",
      (event) => this.dragMove(event),
      false
    );

    document.addEventListener(
      "gallery:swipe-end",
      () => {
        const dragProductInfo = new DragProductInfo();
        dragProductInfo.openInfo();
      },
      false
    );
  }

  openInfo() {
    this.productInfo.classList.add("is-active", "transition");
    document.querySelector("body").classList.add("drag-info-active");
  }

  dragStart(event) {
    if (event.type === "touchstart") {
      this.initialY = event.touches[0].clientY;
    } else {
      this.initialY = event.clientY;
    }

    this.active = true;
  }

  dragEnd() {
    this.initialY = this.currentY;
    this.active = false;

    if (this.currentY > 100) {
      if (this.productInfo.classList.contains("first-time")) {
        this.productInfo.classList.remove("is-active");
        document.querySelector("body").classList.remove("drag-info-active");
      } else {
        this.productInfo.classList.add("first-time");
      }
      this.scalpersSliderComponentEl.classList.remove("overflow-hidden");
    } else if (this.currentY < -80) {
      this.productInfo.classList.add("is-active");
      document.querySelector("body").classList.add("drag-info-active");
      this.scalpersSliderComponentEl.classList.add("overflow-hidden");
      this.classList.remove("color-picker-toggled");
      if (this.productInfo.classList.contains("first-time")) {
        this.productInfo.classList.remove("first-time");
      } else {
        this.productInfo.classList.add("first-time");
      }
    } else {
      this.productInfo.classList.add("is-active");
      document.querySelector("body").classList.add("drag-info-active");
      this.productInfo.classList.add("first-time");
    }

    this.productInfo.style.transform = "";
    this.currentY = 0;

    this.setTranslate();

    this.productInfo.classList.add("transition");

    setTimeout(() => {
      this.productInfo.classList.remove("transition");
    }, 450);
  }

  dragMove(event) {
    if (!this.active) {
      return;
    }
    event.preventDefault();
    if (event.type === "touchmove") {
      this.currentY = event.touches[0].clientY - this.initialY;
    } else {
      this.currentY = event.clientY - this.initialY;
    }
    this.yOffset = this.currentY;
    this.setTranslate();
  }

  setTranslate() {
    if (this.productInfo.classList.contains("is-active")) {
      this.productInfo.style.transform = `translate3d(0, ${this.currentY}px, 0)`;
    } else {
      this.productInfo.style.transform = `translate3d(0, ${this.currentY}px, 0)`;
    }

    if (this.currentY == 0) {
      this.productInfo.style.transform = "unset";
    }
  }
}

customElements.define("drag-product-info", DragProductInfo);

class VariantRadiosPdf extends VariantRadios {
  constructor() {
    super();
    this.currentSizeEl = this.querySelector(
      ".rocket-scalpers-pdf-sticky__variant-size-name"
    );
    this.currentColorEl = this.querySelector(
      ".rocket-scalpers-pdf-sticky__variant-color"
    );
    this.stickyBarWrapper = this.closest(
      ".rocket-scalpers-pdf-sticky__container"
    );
    this.querySelectorAll(
      ".rocket-scalpers-pdf-sticky__option-wrapper"
    ).forEach((el) => {
      el.addEventListener("click", () => {
        let currentActiveEl = this.querySelector(
          ".rocket-scalpers-pdf-sticky__option-wrapper.active"
        );
        if (currentActiveEl && currentActiveEl != el) {
          currentActiveEl.classList.remove("active");
        }
        el.classList.toggle("active");
      });
    });
    this.querySelectorAll(".product-form__input.fieldset-box").forEach((el) => {
      el.addEventListener("click", () => {
        this.closest(
          ".rocket-scalpers-pdf-sticky__option-wrapper"
        )?.classList.remove("active");
      });
    });
    if (this.stickyBarWrapper) {
      let addBtn = this.stickyBarWrapper.querySelector(
        "button.product-form__submit"
      );
      if (addBtn) {
        addBtn.addEventListener("click", () => {
          this.querySelector(
            ".rocket-scalpers-pdf-sticky__option-wrapper.active"
          )?.classList.remove("active");
        });
      }
    }
  }
  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, "", false);
    this.updatePickupAvailability();
    this.updateVariantStatuses();
    this.closeOptionPopup();
    this.updateStickyBar();
    if (!this.currentVariant) {
      this.toggleAddButton(true, "", true);
      this.setUnavailable();
    } else {
      this.updateVariantInput();
      this.renderProductInfo();
    }
  }
  updateStickyBar() {
    let selectedColorOption = this.getOptionSelected("color");
    let selectedSizeOption = this.getOptionSelected("size");
    this.currentSizeEl.innerText = selectedSizeOption.value;
    // this.updateColorPicker(selectedColorOption.value);
  }
  getOptionSelected(optionName) {
    return this.querySelector(
      `.fieldset-${optionName} input[type=radio]:checked`
    );
  }
  closeOptionPopup() {
    this.querySelectorAll(
      ".rocket-scalpers-pdf-sticky__option-wrapper.active"
    ).forEach((el) => el.classList.remove("active"));
  }
  updateColorPicker(colorText) {
    if (!this.currentColorEl) return;
    let colorCube = this.currentColorEl.querySelector(".variant-options-color");
    let colorTextEl = this.currentColorEl.querySelector(
      ".rocket-scalpers-pdf-sticky__variant-color-name"
    );
    colorTextEl.innerText = colorText;
    let classList = colorCube.getAttribute("class");
    let colorClass = colorText.toLowerCase().replace(" ", "");
    colorCube.setAttribute(
      "class",
      classList.replace(
        /(^|\s)rocket-scalpers-product-card__swatch--\S+/g,
        " rocket-scalpers-product-card__swatch--" + colorClass + " "
      )
    );
  }
}

customElements.define("variant-radios-pdf", VariantRadiosPdf);

class ListDragging extends HTMLElement {
  constructor() {
    super();
    this.mouseDown = false;
    this.startX = null;
    this.scrollToLeft = null;
    this.addEventListener("mousemove", this.move, false);
    this.addEventListener("mousedown", this.startDragging, false);
    this.addEventListener("mouseup", this.stopDragging, false);
    this.addEventListener("mouseleave", this.stopDragging, false);
    this.addEventListener("touchmove", this.stopPropagation, false);
    this.addEventListener("touchstart", this.stopPropagation, false);
  }
  stopPropagation(event) {
    event.stopPropagation();
  }
  startDragging(event) {
    this.mouseDown = true;
    this.startX = event.pageX - this.offsetLeft;
    this.scrollToLeft = this.scrollLeft;
  }
  stopDragging(event) {
    event.preventDefault();
    this.mouseDown = false;
  }
  move(event) {
    event.preventDefault();
    if (!this.mouseDown) {
      return;
    }
    const x = event.pageX - this.offsetLeft;
    const scroll = x - this.startX;
    this.scrollLeft = this.scrollToLeft - scroll;
  }
}
customElements.define("list-dragging", ListDragging);

class ImageListDragging extends ListDragging {
  constructor() {
    super();
    this.mouseDown = false;
    this.startX = null;
    this.scrollToLeft = null;
    this.items = this.querySelectorAll(
      ".rocket-scalpers-filters-with-images__type-item"
    );
    this.facet = document.querySelector("facet-filters-form");
    this.facetForm = this.facet.querySelector("form");
    this.facet
      .querySelector(".mobile-facets__clear-wrapper .mobile-facets__clear")
      .setAttribute("filter-image", true);
    this.addEventListener("mousemove", this.move, false);
    this.addEventListener("mousedown", this.startDragging, false);
    this.addEventListener("mouseup", this.stopDragging, false);
    this.addEventListener("mouseleave", this.stopDragging, false);
    this.hideProductTypeInFacet();
    let urlParams = new URLSearchParams(window.location.search);
    let currentType = urlParams.get("filter.p.product_type");
    if (currentType) {
      currentType = currentType.replace("+", " ");
      this.querySelector(
        `.rocket-scalpers-filters-with-images__type-item[filter-value='${currentType}']`
      )?.classList.add("active");
    } else {
      this.querySelector(
        `.rocket-scalpers-filters-with-images__type-item`
      )?.classList.add("active");
    }

    if (screen.width > 767) {
      let imageListCount = this.items.length;
      let listWidth = 197 * imageListCount + 24 * (imageListCount - 1);
      if (listWidth > screen.width) {
        this.classList.add("flex-start");
      }
    }

    this.items.forEach((item) => {
      item.addEventListener("click", () => {
        if (!item.classList.contains("active")) {
          this.classList.add("inactive");
          this.querySelector(
            ".rocket-scalpers-filters-with-images__type-item.active"
          )?.classList.remove("active");
          item.classList.add("active");
          this.uncheckAllProductType();
          let itemValue = item.getAttribute("filter-value");
          let option = this.facet.querySelector(
            `[name='filter.p.product_type'][value='${itemValue}']`
          );
          if (option || itemValue.toLowerCase() == "all") {
            if (option) option.checked = true;
            let inputEvent = new Event("input", { bubbles: true });
            inputEvent.imageFilter = true;
            this.facetForm.dispatchEvent(inputEvent);
          }
          setTimeout(() => {
            this.classList.remove("inactive");
          }, 2000);
        }
      });
    });
  }
  hideProductTypeInFacet() {
    let option = this.facet.querySelector("[name='filter.p.product_type']");
    if (option) {
      option.closest(".mobile-facets__details").style.display = "none";
    }
  }

  uncheckAllProductType() {
    let options = this.facet.querySelectorAll(
      "input[name='filter.p.product_type']"
    );
    options.forEach((option) => {
      option.checked = false;
    });
  }
}
customElements.define("image-list-dragging", ImageListDragging);

if (!customElements.get("accordion-toggle")) {
  class Accordion extends HTMLElement {
    constructor() {
      super();
      this.init();
    }

    init() {
      this.summary = this.querySelector(".summary");
      this.details = this.querySelector(".details");
      this.summary.addEventListener("click", this.toggle.bind(this));
      if (this.classList.contains("active")) {
        this.details.style.maxHeight = this.details.scrollHeight + "px";
      }
    }

    toggle() {
      if (this.classList.contains("active")) {
        this.details.style.maxHeight = 0;
      } else {
        this.details.style.maxHeight = this.details.scrollHeight + "px";
      }
      this.classList.toggle("active");
    }
  }

  customElements.define("accordion-toggle", Accordion);
}

class AddAllModal extends ModalDialog {
  constructor() {
    super();
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector(".template-popup");
    document.body.classList.add("overflow-hidden");
    this.setAttribute("open", "");
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
    if (this.querySelector(".add-all-modal__wrapper")) {
      if (this.querySelector(".product-single-form")) {
        this.ids = this.querySelector(
          ".product-single-form"
        ).dataset.products.split(",");
        this.items = {
          items: this.ids.map((id) => ({ id: id, quantity: 1 })),
        };
        this.config = fetchConfig("javascript");
        this.config.headers["X-Requested-With"] = "XMLHttpRequest";
        delete this.config.headers["Content-Type"];

        // Tạo FormData từ đối tượng this.items
        var formData = new FormData();
        this.items.items.forEach((item) => {
          formData.append("id[]", item.id);
          formData.append("quantity[]", item.quantity);
        });

        // Thêm các mục khác vào FormData
        if (document.querySelector("cart-drawer")) {
          formData.append(
            "sections",
            document
              .querySelector("cart-drawer")
              .getSectionsToRender()
              .map((section) => section.id)
          );
          formData.append("sections_url", window.location.pathname);
          document
            .querySelector("cart-drawer")
            .setActiveElement(document.activeElement);
        }

        this.config.body = formData;

        fetch(`${routes.cart_add_url}`, this.config)
          .then((response) => response.json())
          .then((response) => {
            document.querySelector("cart-drawer").renderContents(response);
          });
      }
      if (
        this.querySelector(".add-all-modal__wrapper").classList.contains(
          "hidden"
        )
      ) {
        this.hide();
      }
    }
  }

  hide() {
    if (!this.classList.contains("add-all-modal")) {
      document.body.classList.remove("overflow-hidden");
    }
    document.body.dispatchEvent(new CustomEvent("modalClosed"));
    this.removeAttribute("open");
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
    if (this.querySelector(".add-all-modal__wrapper")) {
      document
        .querySelector(".rocket-scalpers-product-interested")
        .classList.remove("hidden");
    }
  }
}
customElements.define("add-all-modal", AddAllModal);

class SpecialProductCards extends HTMLElement {
  constructor() {
    super();
    this.template = this.querySelector("template");
    this.section = this.parentNode;
    this.observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            this.convertTemplate();
            if (this.dataset.vertical) {
              this.initSpecialCardSwiper(this.section);
              this.init();
            }
            this.observer.disconnect();
          }
        });
      },
      { rootMargin: "0px 0px 200px 0px" }
    );
    this.observer.observe(this);
  }
  convertTemplate() {
    if (!this.template) return;
    let container = this.template.parentNode;
    let clone = document.importNode(this.template.content, true);
    container.appendChild(clone);
  }
  init() {
    document
      .querySelectorAll(
        ".carousel-rlp__size-selector-mb .rocket-scalpers-product-card__size-close"
      )
      .forEach((btn) => {
        btn.addEventListener("click", () => {
          document.querySelector("body").style.overflowY = "unset";
          if (document.querySelector("drag-product-info")) {
            document.querySelector("drag-product-info").style.overflowY =
              "visible";
          }
          document
            .querySelectorAll(
              ".carousel-rlp__size-selector-mb .rocket-scalpers-product-card__overlay"
            )
            .forEach((x) => (x.style.display = "none"));
          document
            .querySelectorAll(
              ".carousel-rlp__size-selector-mb .rocket-scalpers-product-card__quick-add"
            )
            .forEach((item) => {
              item.classList.remove("open");
            });
          if (btn.closest("section")) {
            btn.closest("section").classList.remove("z-index-10");
          }
        });
      });
  }
  initSpecialCardSwiper(section) {
    if (!section) return;
    const swiperElement = section.querySelector(
      " .rocket-scalpers--special-products__list"
    );
    const wrapper = swiperElement.querySelector(" .swiper-wrapper");
    const productCard = section.querySelectorAll("product-card");
    const spacingDesktop = parseInt(swiperElement.dataset.spacingDesktop || 0);
    const spacingMobile = parseInt(swiperElement.dataset.spacingMobile || 0);
    const condition = parseInt(swiperElement.dataset.sliderCondition);
    const productCount = productCard.length;
    const spacing = window.innerWidth > 768 ? spacingDesktop : spacingMobile;
    const productWidth =
      Array.from(productCard).reduce((acc, item) => {
        return acc + item.offsetWidth;
      }, 0) +
      (productCard.length - 1) * spacing;
    if (productCount > 1 && swiperElement.offsetWidth < productWidth - 1) {
      const swiper = new Swiper(swiperElement, {
        slidesPerView: "auto",
        spaceBetween: productCard.length > 1 ? spacingMobile : 0,
        centerInsufficientSlides: true,
        breakpoints: {
          // when window width is >= 320px
          768: {
            spaceBetween: productCard.length > 1 ? spacingDesktop : 0,
          },
        },
      });
    }
  }
}
customElements.define("special-products-cards", SpecialProductCards);
